// PredkontacieTab — Nastavenia → Účtovanie (ústava 15.2: VŠETKO nastaviteľné)
// Kategória bločku → MKsoft predkontačný KÓD (hotovosť/karta) + účet/podúčet + % základu + % DPH.
// BLOCKY_KONTROLA_V1 (23. 10. 2026, ústava 86.13): + účet nedaňovej časti (zvyšok základu a neuplatnená DPH pri % < 100, napr. PHM 80/50) — vypĺňa back office; ukladá sa cez /api/uctovny-export/kontrola/predkontacia/:id.
import React, { useState, useEffect } from 'react'
import { COLORS, TYPO, SPACE, RADIUS } from '../theme.js'
import { fetchAuth } from '../auth/fetchAuth.js'
import { useToast } from '../components/Toast.jsx'
import { BtnAdd, BtnGhost } from '../components/Btn.jsx'

const inp = { padding: '5px 7px', border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.sm, fontFamily: 'inherit', fontSize: TYPO.sizes.sm, width: '100%', boxSizing: 'border-box' }
const num = { ...inp, width: 58, textAlign: 'right' }
const sel = { ...inp, minWidth: 150 }

export default function PredkontacieTab() {
  const toast = useToast()
  const [rows, setRows] = useState([])
  const [mk, setMk] = useState([])          // MKsoft predkontácie
  const [dirty, setDirty] = useState({})
  const [busy, setBusy] = useState(false)
  const [newKat, setNewKat] = useState('')

  const load = () => fetchAuth('/api/predkontacie').then(r => r.ok ? r.json() : []).then(d => { setRows(Array.isArray(d) ? d : []); setDirty({}) }).catch(() => {})
  useEffect(() => {
    load()
    fetchAuth('/api/mksoft-predkontacie').then(r => r.ok ? r.json() : []).then(d => setMk(Array.isArray(d) ? d : [])).catch(() => {})
  }, [])

  const cashOpts = mk.filter(m => m.typ === 'P')
  const cardOpts = mk.filter(m => m.typ === 'I')

  const edit = (id, field, val) => { setRows(rs => rs.map(r => r.id === id ? { ...r, [field]: val } : r)); setDirty(d => ({ ...d, [id]: true })) }
  const save = async (row) => {
    setBusy(true)
    try {
      const r = await fetchAuth(`/api/predkontacie/${row.id}`, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(row) }); if (!r.ok) throw new Error('HTTP ' + r.status)
      const r2 = await fetchAuth(`/api/uctovny-export/kontrola/predkontacia/${row.id}`, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ ucet_nedanovy: row.ucet_nedanovy || '' }) })   // BLOCKY_KONTROLA_V1
      if (!r2.ok) { const d = await r2.json().catch(() => ({})); throw new Error(d.error || 'HTTP ' + r2.status) }
      setDirty(d => { const n = { ...d }; delete n[row.id]; return n })
    }
    catch (e) { toast.error('Chyba: ' + e.message) } finally { setBusy(false) }
  }
  const saveAll = async () => { for (const r of rows.filter(r => dirty[r.id])) await save(r); toast.success('Uložené') }
  const addKat = async () => {
    if (!newKat.trim()) return
    setBusy(true)
    try { await fetchAuth('/api/predkontacie', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ kategoria: newKat.trim(), zaklad_pct: 100, dph_pct: 100 }) }); setNewKat(''); load() }
    catch (e) { toast.error('Chyba: ' + e.message) } finally { setBusy(false) }
  }
  const del = async (id) => { if (!window.confirm('Zmazať kategóriu?')) return; await fetchAuth(`/api/predkontacie/${id}`, { method: 'DELETE' }); load() }

  const dirtyCount = Object.keys(dirty).length
  const td = { padding: '5px 7px', borderBottom: `1px solid ${COLORS.lineSoft || COLORS.line}`, fontSize: TYPO.sizes.sm, verticalAlign: 'top' }

  return (
    <div style={{ background: COLORS.bg, border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.lg, padding: SPACE.lg }}>
      <h3 style={{ margin: 0, marginBottom: SPACE.sm }}>Účtovanie bločkov — predkontácie</h3>
      <div style={{ padding: SPACE.sm, background: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: RADIUS.sm, fontSize: TYPO.sizes.xs, color: '#1e40af', marginBottom: SPACE.md, lineHeight: 1.5 }}>
        Ku každej kategórii bločku vyber <b>MKsoft predkontačný KÓD</b> — zvlášť pre <b>hotovosť</b> (pokladničný doklad, DAL 211) a <b>kartu</b> (interný doklad, DAL 261110). MKsoft podľa KÓDu rozúčtuje sám (vrátane 80/50 splitu, 501NNAK/501NDPH). Pri skene/QR sa KÓD priradí automaticky podľa kategórie + spôsobu platby.
      </div>

      <div style={{ overflowX: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead><tr>
            {['Kategória bločku', 'KÓD hotovosť', 'KÓD karta', 'Účet', 'Účet nedaň. časti', 'Zákl%', 'DPH%', 'Poznámka', ''].map(h =>
              <th key={h} style={{ ...td, textAlign: 'left', color: COLORS.muted, fontWeight: TYPO.weights.semibold, fontSize: TYPO.sizes.xs, textTransform: 'uppercase', position: 'sticky', top: 0, zIndex: 3, background: COLORS.bgSoft, borderBottom: `2px solid ${COLORS.line}`, boxShadow: `0 1px 0 ${COLORS.line}` }}>{h}</th>)}
          </tr></thead>
          <tbody>
            {rows.map(r => (
              <tr key={r.id} style={{ background: dirty[r.id] ? '#fffbeb' : 'transparent' }}>
                <td style={{ ...td, fontWeight: 600 }}>{r.kategoria}</td>
                <td style={td}>
                  <select style={sel} value={r.kod_hotovost || ''} onChange={e => edit(r.id, 'kod_hotovost', e.target.value)}>
                    <option value="">— vyber —</option>
                    {cashOpts.map(o => <option key={o.kod} value={o.kod}>{o.kod} · {o.popis}</option>)}
                  </select>
                </td>
                <td style={td}>
                  <select style={sel} value={r.kod_karta || ''} onChange={e => edit(r.id, 'kod_karta', e.target.value)}>
                    <option value="">— vyber —</option>
                    {cardOpts.map(o => <option key={o.kod} value={o.kod}>{o.kod} · {o.popis}</option>)}
                  </select>
                </td>
                <td style={td}><input style={{ ...inp, width: 90, fontFamily: TYPO.mono }} value={r.ucet || ''} onChange={e => edit(r.id, 'ucet', e.target.value)} placeholder="501500" /></td>
                <td style={td}><input style={{ ...inp, width: 90, fontFamily: TYPO.mono }} value={r.ucet_nedanovy || ''} onChange={e => edit(r.id, 'ucet_nedanovy', e.target.value)} placeholder={(Number(r.zaklad_pct) < 100 && Number(r.zaklad_pct) > 0) || (Number(r.dph_pct) < 100 && Number(r.dph_pct) > 0) ? 'doplň' : '—'} title="Účet, na ktorý ide nedaňová časť (zvyšok základu a neuplatnená DPH), keď Zákl% alebo DPH% je menej ako 100 — napr. PHM 80/50. Pri 0 % ide celá suma na Účet." /></td>
                <td style={td}><input style={num} type="number" value={r.zaklad_pct} onChange={e => edit(r.id, 'zaklad_pct', parseFloat(e.target.value) || 0)} /></td>
                <td style={td}><input style={num} type="number" value={r.dph_pct} onChange={e => edit(r.id, 'dph_pct', parseFloat(e.target.value) || 0)} /></td>
                <td style={td}><input style={inp} value={r.poznamka || ''} onChange={e => edit(r.id, 'poznamka', e.target.value)} /></td>
                <td style={{ ...td, whiteSpace: 'nowrap' }}>
                  {dirty[r.id] && <span onClick={() => save(r)} style={{ cursor: 'pointer', color: COLORS.add, fontWeight: 700, marginRight: 8 }} title="Uložiť">✓</span>}
                  <span onClick={() => del(r.id)} style={{ cursor: 'pointer', color: COLORS.remove }} title="Zmazať"></span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div style={{ display: 'flex', gap: SPACE.sm, alignItems: 'center', marginTop: SPACE.md, flexWrap: 'wrap' }}>
        <input style={{ ...inp, width: 240 }} value={newKat} onChange={e => setNewKat(e.target.value)} placeholder="Nová kategória…" />
        <BtnGhost onClick={addKat} disabled={busy}>+ Pridať kategóriu</BtnGhost>
        {dirtyCount > 0 && <BtnAdd onClick={saveAll} disabled={busy} style={{ marginLeft: 'auto' }}>Uložiť zmeny ({dirtyCount})</BtnAdd>}
      </div>
    </div>
  )
}
